"use client";

import type { BaseComponentProps } from "@json-render/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

export type VizCardProps = BaseComponentProps<{
  title?: string | null;
  description?: string | null;
  footnote?: string | null;
}>;

/**
 * AI 可視化カードの情報階層を固定する shell。
 *
 * @remarks
 * カード上部は title + description に限定し、補足は footer へ寄せることで
 * チャート自体の視線移動を減らす。
 */
export function VizCard({ props, children }: VizCardProps) {
  const { title, description, footnote } = props;
  const hasHeader = Boolean(title || description);

  return (
    <Card data-viz-card-root="true" className="w-full min-w-0 overflow-hidden">
      {hasHeader ? (
        <CardHeader className="space-y-1.5 px-4 pt-3 pb-1.5">
          {title ? (
            <CardTitle className="text-base leading-tight tracking-tight">
              {title}
            </CardTitle>
          ) : null}
          {description ? (
            <CardDescription className="text-sm leading-5">
              {description}
            </CardDescription>
          ) : null}
        </CardHeader>
      ) : null}
      <CardContent className={cn("px-4 pb-2", !hasHeader ? "pt-3" : "pt-0")}>
        {children}
      </CardContent>
      {footnote ? (
        <CardFooter className="px-4 pt-0.5 pb-3 text-xs leading-5 text-muted-foreground">
          {footnote}
        </CardFooter>
      ) : null}
    </Card>
  );
}
